import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { Lightbulb } from '@liveauctioneers/hammer-ui-core/icons';
import FormattedMessageText from '@/components/Formatted/FormattedMessageText';

type Props = {
    className?: string;
    messageId: string;
};

export const ProTip = ({ className, messageId }: Props) => {
    return (
        <div
            className={cn(
                'flex items-center gap-xs rounded-lg border border-border-secondary bg-background-info-light p-sm',
                className
            )}
        >
            <Lightbulb
                color="info"
                size="sm"
                style="fill"
            />
            <BodyPrimary className="text-text-primary">
                <FormattedMessageText id={messageId} />
            </BodyPrimary>
        </div>
    );
};
